// studiosSaga.ts

import { call, put, select,takeLatest } from "redux-saga/effects";

import { API } from "../../api";
import {
  getFilteredUsers,
  getFilteredUsersFailure,
  getFilteredUsersSuccess,
  getUsers,
  getUsersFailure,
  getUsersSuccess,
  inviteUser,
  inviteUserFailure,
  inviteUserSuccess,
  resendUserSms,
  resendUserSmsFailure,
  resendUserSmsSuccess,
  verifyUserPhone,
  verifyUserPhoneFailure,
  verifyUserPhoneSuccess,
} from "../reducers/usersSlice";

import { errorHandler } from "./common";

function* getUsersSaga() {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, "/users", {
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(getUsersSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: getUsersSaga,
      *callback () {
        yield put(getUsersFailure(error));
      },
    });
  }
}

function* getFilteredUsersSaga(action: any) {
  try {
    const searchParams = action.payload;
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(API.get, "/users", {
      params: {
        ...searchParams,
      },
      headers: {
        Authorization: `Bearer ${  token}`,
      },
    });

    yield put(getFilteredUsersSuccess(response.data.data));
  } catch (error: any) {
    yield errorHandler({
      error,
      recallCallback: getFilteredUsersSaga,
      *callback () {
        yield put(getFilteredUsersFailure(error));
      },
    });
  }
}

interface inviteUserSagaProp {
  payload: {
    firstName: string;
    lastName: string;
    phone: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* inviteUserSaga({
  payload: { firstName, lastName, phone, onSuccess, onFailure },
}: inviteUserSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/users/invite`,
      {
        firstName,
        lastName,
        phone,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(inviteUserSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield inviteUserSaga({
          payload: {
            firstName,
            lastName,
            phone,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(inviteUserFailure(error));
        onFailure(error);
      },
    });
  }
}

interface resendUserSmsProp {
  payload: {
    phone: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* resendUserSmsSaga({
  payload: { phone, onSuccess, onFailure },
}: resendUserSmsProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/auth/sign-up/resend-sms`,
      {
        phone,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(resendUserSmsSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield resendUserSmsSaga({
          payload: {
            phone,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(resendUserSmsFailure(error));
        onFailure(error);
      },
    });
  }
}

interface verifyUserPhoneSagaProp {
  payload: {
    code: string;
    onSuccess: () => void;
    onFailure: (error: any) => void;
  };
}

function* verifyUserPhoneSaga({
  payload: { code, onSuccess, onFailure },
}: verifyUserPhoneSagaProp) {
  try {
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    yield call<any>(
      API.post,
      `/auth/verify-phone`,
      {
        token: code,
      },
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(verifyUserPhoneSuccess());
    onSuccess();
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield verifyUserPhoneSaga({
          payload: {
            code,
            onSuccess,
            onFailure,
          },
        });
      },
      *callback () {
        yield put(verifyUserPhoneFailure(error));
        onFailure(error);
      },
    });
  }
}

// Watcher Saga
export function* usersSaga() {
  // @ts-ignore
  yield takeLatest(getUsers().type, getUsersSaga);
  // @ts-ignore
  yield takeLatest(getFilteredUsers().type, getFilteredUsersSaga);
  // @ts-ignore
  yield takeLatest(inviteUser().type, inviteUserSaga);
  // @ts-ignore
  yield takeLatest(resendUserSms().type, resendUserSmsSaga);
  // @ts-ignore
  yield takeLatest(verifyUserPhone().type, verifyUserPhoneSaga);
}
